module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anchor Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ABRL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anchor Bible Reference Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ANET")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(". Edited by J. B. Pritchard. 3rd ed. Princeton: Princeton University Press, 1969")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BA")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Archaeologist")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Archaeology Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BASOR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin of the American Schools of Oriental Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BBB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bonner biblische Beiträge")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brown, F., S. R. Driver, and C. A. Briggs. "), _c('em', [_vm._v("A Hebrew and English Lexicon of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BHK")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblia Hebraica")]), _vm._v(". Edited by R. Kittel. Leipzig: Hinrichs, 1905–1906")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BHQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblia Hebraic Quinta")]), _vm._v(". Edited by A. Schenker et al. Stuttgart: Deutsche Bibelgesellschaft, 2004–")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BHS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblia Hebraica Stuttgartensia")]), _vm._v(". Edited by K. Elliger and W. Rudolph. Stuttgart: Deutsche Bibelgesellschaft, 1983")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BibInt")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BJSUCSD")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblical and Judaic Studies from the University of California, San Diego")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BN")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblische Notizen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZAW")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Beihefte zur")]), _vm._v(" "), _c('em', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CAP")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cowley, A. E. "), _c('em', [_vm._v("Aramaic Papyri of the Fifth Century B.C.")]), _vm._v(" Oxford: Clarendon, 1923")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CBET")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Contributions to Biblical Exegesis and Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CHJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Cambridge History of Judaism")]), _vm._v(". Edited by W. D. Davies and L. Finkelstein. 4 vols. Cambridge: Cambridge University Press, 1984–2006")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DCH")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dictionary of Classical Hebrew.")]), _vm._v(" Edited by D. J. A. Clines. 9 vols. Sheffield: Sheffield Phoenix, 1993–2014")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DEJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Eerdmans Dictionary of Early Judaism")]), _vm._v(". Edited by J. J. Collins and D. C. Harlow. Grand Rapids: Eerdmans, 2010")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DJD")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Discoveries in the Judaean Desert")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DSD")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dead Sea Discoveries")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FAT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forschungen zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("FGH")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Die Fragmente der griechischen Historiker")]), _vm._v(". Edited by F. Jacoby. Leiden: Brill, 1954–1964")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HALOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Hebrew and Aramaic Lexicon of the Old Testament.")]), _vm._v(" L. Koehler, W. Baumgartner, and J. J. Stamm. Translated and edited under the supervision of M. E. J. Richardson. 5 vols. Leiden: Brill, 1994–2000")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HAT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Handbuch zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HSM")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Harvard Semitic Monographs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Interpreter’s Bible.")]), _vm._v(" 12 vols. Edited by G. A. Buttrick et al. Nashville: Abingdon, 1953–56")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IEJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Israel Exploration Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JAJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Ancient Judaism")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JAJSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to the Journal of Ancient Judaism")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JAOS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the American Oriental Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JQR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jewish Quarterly Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of Judaism")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSJSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to the Journal for the Study of Judaism")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSOTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the Old Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jewish Studies Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("KAT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kommentar zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LCL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LHBOTS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Library of Hebrew Bible/Old Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NAC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The New American Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A New English Translation of the Septuagint")]), _vm._v(". Edited by A. Pietersma and B. G. Wright. New York: Oxford University Press, 2007")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OBO")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Orbis Biblicus et Orientalis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Testament Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Old Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PEQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Palestine Exploration Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PFT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Persepolis Fortification Tablets")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue Biblique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RevQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue de Qumran")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLMS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Monograph Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ScrHier")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Scripta Hierosolymitana")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("STDJ")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies on the Texts of the Desert of Judah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SVTP")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studia in Veteris Testamenti Pseudepigraphica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SymS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Symposium Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TAD")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Textbook of Aramaic Documents from Ancient Egypt.")]), _vm._v(" Translated and edited by B. Porten and A. Yardeni. 4 vols. Jerusalem: Hebrew University Press, 1986–1999")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TBC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Torch Biblical Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the Old Testament")]), _vm._v(". Edited by G. Johannes Botterweck, H. Ringgren, and H.-J. Fabry. 17 vols. Grand Rapids: Eerdmans, 1980–2020")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TOTC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tyndale Old Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("VTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to Vetus Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WUNT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZAW")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZDPV")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift des Deutschen Palästina-Vereins")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf6f51d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Abbreviations.vue
// module id = 78
// module chunks = 0